import blogThumbnail1 from './assets/How-to-Choose-the-Right-Salon-for-Your-Beauty-Needs.png';
import blogThumbnail2 from './assets/best-colouring-options-for-grey-hair.png';

export const BLOG_POSTS_STORAGE_KEY = 'blogsAdminPosts';

export const getBlogPosts = () => {
  if (typeof window === 'undefined') {
    return blogPosts;
  }

  try {
    const saved = window.localStorage.getItem(BLOG_POSTS_STORAGE_KEY);
    return saved ? JSON.parse(saved) : blogPosts;
  } catch (error) {
    return blogPosts;
  }
};

export const blogPosts = [
  {
    id: 1,
    slug: 'how-to-choose-right-salon',
    title: 'How to Choose the Right Salon for Your Beauty Needs',
    date: 'December 20, 2024',
    category: 'Beauty Tips',
    image: blogThumbnail1,
    description: 'Choosing the right salon is not just about getting a haircut or facial. It is about trusting someone with your appearance, confidence, and self-care. With so many options available, finding the',
    descriptionWithLink: 'best salon in Visakhapatnam',
    descriptionAfterLink: ' can feel confusing. Here’s a simple guide to help you make the right choice for your beauty and grooming needs.',
    postUrl: 'https://celebritycuts.in/',
    content: 'Check hygiene and cleanliness\nLook at the range of services\nCheck the experience of stylists\nRead reviews and testimonials\nUnderstand the products they use\nCompare pricing and transparency\nCustomer service matters\nVisit for a consultation first',
    sections: [
      {
        heading: '1. Check Hygiene and Cleanliness',
        content: 'The first thing you should notice when you walk into a salon is cleanliness. Tools should be sanitized, towels should be fresh, and workstations should be neat. A clean salon demonstrates professionalism and a commitment to clients’ safety. Hygiene is especially important for services like facials, waxing, manicures, and pedicures.'
      },
      {
        heading: '2. Look at the Range of Services',
        content: 'A good salon should offer a variety of services, including haircuts, styling, hair treatments, facials, makeup, and nail care. Even if you need only one service now, it is helpful to choose a salon that can meet your future beauty needs as well.'
      },
      {
        heading: '3. Check the Experience of Stylists',
        content: 'Experienced professionals make a big difference. Skilled stylists understand different hair types, skin tones, and face shapes. They also suggest treatments that suit you instead of pushing unnecessary services. Do not hesitate to ask about their experience or certifications.'
      }
    ],
    conclusion: 'The right salon should make you feel confident, comfortable, and truly valued. Take your time to research, visit, and compare before making a decision. When you choose a professional hair and beauty service in Visakhapatnam that understands your beauty goals and maintains high standards of hygiene and expertise, every visit becomes a relaxing and satisfying experience.'
  },
  {
    id: 2,
    slug: 'struggling-with-grey-hair-best-colouring-options',
    title: 'Struggling with Grey Hair? Best Colouring Options',
    date: 'March 21, 2024',
    category: 'Hair Care',
    image: blogThumbnail2,
    description: 'Grey hair is a natural part of aging, but for many people, it can appear earlier than expected. Whether it’s a few strands or a full head of greys, choosing the right colouring option can help you feel more confident and refreshed. The good news is, there are plenty of solutions available today, depending on your style, budget, and maintenance preferences. If you’re looking for expert guidance and quality results, visiting the',
    descriptionWithLink: 'best hair salon in Visakhapatnam',
    descriptionAfterLink: ' can make all the difference, as professional stylists can recommend the most suitable colouring options for your hair type and lifestyle.',
    postUrl: 'https://celebritycuts.in/',
    content: 'Permanent hair colour gives long-lasting coverage\nSemi-permanent colour blends grey gently\nHighlights and lowlights create dimension\nRoot touch-up solutions offer quick fixes\nConsider natural colour options like henna\nUse sulphate-free shampoos and masks',
    sections: [
      {
        heading: 'Why Does Hair Turn Grey?',
        content: 'Hair turns grey when the pigment (melanin) in your hair follicles reduces over time. Factors like genetics, stress, lifestyle, and nutrition can also speed up this process. While you can’t completely stop greying, you can definitely manage how it looks.'
      },
      {
        heading: '1. Permanent Hair Colour',
        content: 'Permanent hair colour is one of the most effective ways to cover grey hair completely. It penetrates deep into the hair shaft and provides long-lasting results. Best for: Full grey coverage and long-lasting results. Things to consider: Requires touch-ups every 4–6 weeks and can cause dryness if not maintained properly.'
      },
      {
        heading: '2. Semi-Permanent Hair Colour',
        content: 'This option gently blends greys instead of fully covering them. It gradually fades with each wash, making it a good choice for those who prefer a low-commitment look. Best for: First-time users and light grey blending. Things to consider: Doesn’t fully cover stubborn greys and needs frequent reapplication.'
      }
    ],
    conclusion: 'Grey hair doesn’t have to limit your style. With the right colouring option, you can either fully cover it or blend it beautifully for a modern, confident look. The key is choosing a method that suits your lifestyle and hair type. If you’re unsure which option is best for you, consulting a professional stylist can make all the difference. They can guide you toward a solution that enhances your natural beauty while keeping your hair healthy.'
  }
];
